import React from 'react';
import { Box, Flex, Icon, Text, useColorModeValue } from '@chakra-ui/react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaBook, FaCalendarAlt, FaBookOpen, FaBars } from 'react-icons/fa';

export default function BottomNav({ onOpenMenu }) {
  const location = useLocation();
  const bg = useColorModeValue('rgba(255, 255, 255, 0.85)', 'rgba(26, 32, 44, 0.85)');
  const borderTopColor = useColorModeValue('gray.200', 'gray.700');
  const activeColor = useColorModeValue('brand.600', 'brand.300');
  const inactiveColor = useColorModeValue('gray.500', 'gray.400');

  const navItems = [
    { label: 'Inicio', icon: FaHome, route: '/' },
    { label: 'Biblia', icon: FaBook, route: '/biblia' },
    { label: 'Eventos', icon: FaCalendarAlt, route: '/proximos-eventos' },
    { label: 'Estudio', icon: FaBookOpen, route: '/estudio-biblico' },
  ];

  return (
    <Box
      display={{ base: 'block', md: 'none' }}
      position="fixed"
      bottom="0"
      left="0"
      right="0"
      bg={bg}
      backdropFilter="blur(10px)"
      borderTop="1px solid"
      borderTopColor={borderTopColor}
      zIndex="1100"
      sx={{ paddingBottom: 'env(safe-area-inset-bottom)' }} // iPhone safe area
    >
      <Flex justify="space-around" align="center" h="64px">
        {navItems.map((item, idx) => {
          const isActive = location.pathname === item.route;
          return (
            <Flex
              key={idx}
              as={Link}
              to={item.route}
              flexDir="column"
              align="center"
              justify="center"
              w="100%"
              h="100%"
              color={isActive ? activeColor : inactiveColor}
              _hover={{ textDecoration: 'none' }}
            >
              <Icon as={item.icon} boxSize={5} mb={1} />
              <Text fontSize="10px" fontWeight={isActive ? 'bold' : 'normal'}>
                {item.label}
              </Text>
            </Flex>
          );
        })}
        {/* Extra button to open a Drawer for the rest of the items if needed */}
        <Flex
          as="button"
          onClick={onOpenMenu}
          flexDir="column"
          align="center"
          justify="center"
          w="100%"
          h="100%"
          color={inactiveColor}
          _hover={{ textDecoration: 'none' }}
        >
          <Icon as={FaBars} boxSize={5} mb={1} />
          <Text fontSize="10px" fontWeight="normal">
            Más
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
}
